'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseAlerts = require('@bibliocommons/base-alerts');

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _itemScreenReaderDescription = require('../../item-screen-reader-description');

var _itemScreenReaderDescription2 = _interopRequireDefault(_itemScreenReaderDescription);

require('../styles/SearchResultAddButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  listItems: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  item: _bcPropTypes.listItemShape,
  handleAddBib: _react2.default.PropTypes.func
};

var SearchResultAddButton = function (_BcReactComponent) {
  _inherits(SearchResultAddButton, _BcReactComponent);

  function SearchResultAddButton(props) {
    _classCallCheck(this, SearchResultAddButton);

    var _this = _possibleConstructorReturn(this, (SearchResultAddButton.__proto__ || Object.getPrototypeOf(SearchResultAddButton)).call(this, props));

    _this.bindAll('handleAddBib');
    return _this;
  }

  _createClass(SearchResultAddButton, [{
    key: 'handleAddBib',
    value: function handleAddBib() {
      this.props.handleAddBib(this.props.item);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var itemWasOnList = this.constructor.itemIsOnList(prevProps.listItems, this.props.item);
      var itemIsOnList = this.constructor.itemIsOnList(this.props.listItems, this.props.item);

      if (!itemWasOnList && itemIsOnList && this._itemAddedMessage) {
        this._itemAddedMessage.focus();
      }

      return null;
    }
  }, {
    key: 'renderContents',
    value: function renderContents() {
      var _this2 = this;

      var itemIsOnList = this.constructor.itemIsOnList(this.props.listItems, this.props.item);

      if (itemIsOnList) {
        return _react2.default.createElement(
          'span',
          { tabIndex: '-1', ref: function ref(el) {
              return _this2._itemAddedMessage = el;
            } },
          _react2.default.createElement(
            _reactIntl.FormattedMessage,
            { id: 'button_added' },
            function (message) {
              return _react2.default.createElement(
                _baseScreenReaderMessage2.default,
                null,
                message
              );
            }
          ),
          _react2.default.createElement(
            'span',
            { 'aria-hidden': 'true', className: 'hidden-xs' },
            _react2.default.createElement(
              _baseAlerts.AlertSuccess,
              { className: 'hidden-xs' },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_added' })
            )
          ),
          _react2.default.createElement(
            'span',
            { 'aria-hidden': 'true', className: 'visible-xs icon-only' },
            _react2.default.createElement(
              _baseAlerts.AlertSuccess,
              null,
              _react2.default.createElement('span', null)
            )
          )
        );
      }

      return _react2.default.createElement(
        _baseButtons.Button,
        {
          className: 'btn-ugc add-button',
          'data-test-id': 'add-button',
          flat: true,
          handleClick: this.handleAddBib },
        _react2.default.createElement('i', { 'aria-hidden': true, className: 'icon-plus' }),
        _react2.default.createElement(
          'span',
          { 'aria-hidden': true, className: 'hidden-xs' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add' })
        ),
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'ada_label_add_item_to_list',
            values: { title: _react2.default.createElement(_itemScreenReaderDescription2.default, { item: this.props.item }) } })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-search-result-add-button' },
        this.renderContents()
      );
    }
  }], [{
    key: 'itemIsOnList',
    value: function itemIsOnList(listItems, targetItem) {
      var existingItemIndex = listItems.findIndex(function (item) {
        return item.getIn(['bibListItem', 'id']) === targetItem.getIn(['bibListItem', 'id']);
      });
      return existingItemIndex !== -1;
    }
  }]);

  return SearchResultAddButton;
}(_baseBcReactComponent2.default);

SearchResultAddButton.propTypes = propTypes;

exports.default = SearchResultAddButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/search-result-add-button/components/SearchResultAddButton.component.js
// module id = 1335
// module chunks = 0